







export default
  name: 'SyncIndicator'
